export const PRODUCT_CHANGE_STATUS = {
    UNAVAILABLE: 'UNAVAILABLE',
    MAX_QTY_EXCEED: 'MAX_QTY_EXCEED'
};
